import teleco1 from '../images/teleco_1.jpg';
import teleco2 from '../images/teleco_2.jpg';
import teleco3 from '../images/teleco_3.jpg';
import teleco4 from '../images/teleco_4.jpg';
import teleco5 from '../images/teleco_5.jpg';
import teleco6 from '../images/teleco_6.jpg';
import teleco7 from '../images/teleco_7.jpg';
import teleco8 from '../images/teleco_8.jpg';
import teleco9 from '../images/teleco_9.jpg';
import teleco10 from '../images/teleco_10.jpg';
import teleco11 from '../images/teleco_11.jpg';
import teleco12 from '../images/teleco_12.jpg';
import teleco13 from '../images/teleco_13.jpg';
import teleco14 from '../images/teleco_14.jpg';
import teleco15 from '../images/teleco_15.jpg';
import teleco16 from '../images/teleco_16.jpg';
import teleco17 from '../images/teleco_17.jpg';
import teleco18 from '../images/teleco_18.jpg';
import teleco19 from '../images/teleco_19.jpg';
import teleco20 from '../images/teleco_20.jpg';
import teleco21 from '../images/teleco_21.jpg';
import teleco22 from '../images/teleco_22.jpg';
import teleco23 from '../images/teleco_23.jpg';
import teleco24 from '../images/teleco_24.jpg';
import teleco25 from '../images/teleco_25.jpg';
import teleco26 from '../images/teleco_26.jpg';

const telecom_data = {
  productDevelopment : {
    client: "Produce Development / NBN", 
    title: "Power CSD", 
    image_array: [
      {
        image: teleco1,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco2,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco3,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco4,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco5,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco6,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco7,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco8,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco9,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco10,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco11,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco12,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco13,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco14,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco15,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco16,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco17,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco18,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco19,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco20,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco21,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco22,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco23,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco24,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco25,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
      {
        image: teleco26,
        category: "telecommunication", 
        title: 'Power CSD', 
        comment: "Power CSD by Produce Development"
      },
    ]
  },
};

export default telecom_data;